import { render, staticRenderFns } from "./create.vue?vue&type=template&id=c55ec368&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c55ec368')) {
      api.createRecord('c55ec368', component.options)
    } else {
      api.reload('c55ec368', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=c55ec368&", function () {
      api.rerender('c55ec368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/annual-return/create.vue"
export default component.exports